<template>
  <div id="app">
    <app-header/>
    <app-messages/>
    <transition
        enter-active-class="animate__animated animate__slideInUp"
        leave-active-class="animate__animated animate__slideInDown"
        mode="out-in">
      <router-view/>
    </transition>
    <app-social-chat/>
    <app-footer/>
  </div>
</template>

<script>
import Header from './components/shared/Header'
import Footer from './components/shared/Footer'
import SocialChat from './components/shared/SocialChat'
import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
  name: 'App',
  components: {
    AppHeader: Header,
    AppFooter: Footer,
    AppSocialChat: SocialChat,
  },
  data(){
    return{}
  },
  methods: {
    ...mapMutations([]),
    ...mapActions([
        'tryAutoLogin'
    ]),
  },
  computed: {
    ...mapGetters([]),
  },
  watch: {},
  beforeCreate() {},
  created() {
    this.tryAutoLogin()
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
}
</script>

<style lang="scss">
@import "assets/css/customized/root";
@import "assets/css/customized/colors";
@import "assets/css/customized/bgColors";
@import "assets/css/customized/buttons";
@import url(https://fonts.googleapis.com/css?family=Roboto+Condensed:400|Roboto:100);

.animate__animated{
  --animate-duration: 0.5s;
}
.font-weight-bold{
  font-weight: bold;
}
#nprogress .bar {
  background: var(--color-seventeenth, rgba(34, 134, 195, 1));
  height: 4px;
}
#app{
  background: var(--color-third);
  font-family: 'Roboto Condensed', serif;
  & > div.message{
    background: transparent;
    text-align: center;
    font-size: large;
    margin: 0 auto;
  }
}
.separator{
  border: none;
  opacity: 1;
  height: 2px;
  background: var(--color-second-radial-gradient-2);
}
.cursor-not-allowed{
  cursor: not-allowed !important;
}
.cursor-text{
  cursor: text !important;
}
/* Start Colors */
// color variables

// background-image gradient classes
/* End Colors */
</style>



// WEBPACK FOOTER //
// src/App.vue